import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import axios from './utils/axios'
import './styles/element-variables.scss'

Vue.use(ElementUI);
Vue.prototype.$axios = axios
Vue.prototype.$tokenKey = '_yunyi_portal_token'

// 客服链接
Vue.prototype.$customerServiceUrl = 'https://t.me/yunyiapp'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
